<template>
    <div v-if="transactions">
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Transactions</h4>
            <router-link class="btn btn-primary"
                    :disabled="loading"
                    :to="{name: 'order', params: {orderType: 'adjustment', id: 'new'}}">
                Adjust stock
            </router-link>
        </div>
        <AppTable :columns="columns"
                      :rows="transactions"
                      :query="query"
                      :loading="loading"
                      :total="total"
                      @on-query-change="onQueryChange">
            <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'warehouse'" class="text-nowrap">
                {{ props.row.dispatching_warehouse ? props.row.dispatching_warehouse.name : 'N/A'}}
                <i class="material-icons md-18">chevron_right</i>
                {{ props.row.receiving_warehouse ? props.row.receiving_warehouse.name : 'N/A'}}
            </span>
            <span v-else-if="props.column.field === 'price'">
                {{ props.formattedRow[props.column.field] | currency(2, '') }}
            </span>
            <span v-else>
                {{ props.formattedRow[props.column.field] }}
            </span>
            </template>
        </AppTable>

    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';
import formatCurrency from '../../filters/currency.filter';

export default {
  components: {
    AppTable,
  },
  filters: {
    currency: formatCurrency,
  },
  computed: {
    ...mapGetters({
      transactions: 'orders/transactions',
    }),
    ...mapState({
      query: (state) => state.orders.transactionsQuery,
      total: (state) => state.orders.totalTransactions,
    }),
    columns() {
      return [
        {
          label: 'Date',
          field: 'order.issued_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
          filterOptions: {
            enabled: true,
          },
        },
        /* {
          label: 'Dispatched at',
          field: 'dispatched_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Received at',
          field: 'received_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
          filterOptions: {
            enabled: true,
          },
        }, */
        {
          label: 'Type',
          field: 'order.type_code',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Warehouse',
          field: 'warehouse',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Product',
          field: 'product.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Price',
          field: 'price',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Quantity',
          field: 'quantity',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Unit',
          field: 'unit_type_code',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Currency',
          field: 'order.currency_code',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Status',
          field: 'status.name',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getTransactions();
  },
  methods: {
    getTransactions() {
      this.loading = true;

      this.$store.dispatch('orders/getTransactions')
        .finally(() => {
          this.loading = false;
        });
    },

    onQueryChange(props) {
      this.$store.commit('orders/transactionsQueryProps', props);
      this.getTransactions();
    },
  },
};
</script>
